import { ThemeConfig, theme } from 'antd';
import { ThemeEnum } from 'types';
import { COLORS } from 'utilities';

export const __theme: (webTheme: ThemeEnum) => ThemeConfig = (webTheme) => ({
    algorithm: theme.defaultAlgorithm,
    components: {
        Input: {
            hoverBorderColor: webTheme === ThemeEnum.light ? COLORS.white : COLORS.black2,
            activeBorderColor: webTheme === ThemeEnum.light ? COLORS.white : COLORS.black2,
            activeShadow: 'transparent',
        },
        InputNumber: {
            colorBorder: webTheme === ThemeEnum.light ? COLORS.white : COLORS.black2,
            hoverBorderColor: webTheme === ThemeEnum.light ? COLORS.white : COLORS.black2,
            activeBorderColor: webTheme === ThemeEnum.light ? COLORS.white : COLORS.black2,
            activeShadow: 'transparent',
        },
        Select: {
            hoverBorderColor: webTheme === ThemeEnum.light ? COLORS.white : COLORS.black2,
            activeBorderColor: webTheme === ThemeEnum.light ? COLORS.white : COLORS.black2,
            optionSelectedBg: COLORS.primary + ' !important',
            optionSelectedColor: COLORS.black2 + ' !important',
        },
        Form: {
            labelColor: webTheme === ThemeEnum.light ? COLORS.black1 : COLORS.gray1,
            labelFontSize: 18,
        },
        Pagination: {
            itemActiveBg: webTheme === ThemeEnum.light ? COLORS.primary : COLORS.black3,
        },
        Result: {
            colorTextDescription: webTheme === ThemeEnum.light ? COLORS.black1 : COLORS.gray1,
        },
        Spin: {
            colorPrimary: COLORS.primary + ' !important',
        },
        Empty: {
            colorTextDescription:
                webTheme === ThemeEnum.dark ? `${COLORS.white} !important` : `${COLORS.black2} !important`,
        },
        TreeSelect: {
            nodeSelectedBg: webTheme === ThemeEnum.dark ? COLORS.primary + ' !important' : undefined,
            nodeSelectedColor: webTheme === ThemeEnum.dark ? COLORS.black2 + ' !important' : undefined,
        },
        Tree: {
            // colorBgBase: 'transparent',
            colorBgContainer: 'transparent',
            nodeSelectedBg: 'transparent',
            nodeSelectedColor: COLORS.primary,
            opacityLoading: 1,
        },
        Tag: {
            defaultBg: webTheme === ThemeEnum.dark ? COLORS.bgDark : undefined,
            colorIcon: webTheme === ThemeEnum.dark ? '#ffffff !important' : undefined,
            defaultColor: webTheme === ThemeEnum.dark ? '#ffffff !important' : undefined,
            colorText: webTheme === ThemeEnum.dark ? '#ffffff !important' : undefined,
            colorTextLightSolid: webTheme === ThemeEnum.dark ? '#ffffff !important' : undefined,
        },
        Checkbox: {
            colorPrimary: `${COLORS.primary} !important`,
            colorBgContainer:
                webTheme === ThemeEnum.light ? `${COLORS.white} !important` : `${COLORS.black2} !important`,
        },
        Radio: {
            colorPrimary: `${COLORS.primary} !important`,
        },
    },
    token: {
        colorText: webTheme === ThemeEnum.light ? `${COLORS.black1} !important` : `${COLORS.gray3} !important`,
        colorTextPlaceholder:
            webTheme === ThemeEnum.light ? `${COLORS.gray3} !important` : `${COLORS.gray2} !important`,
        hoverBorderColor: webTheme === ThemeEnum.light ? `${COLORS.white} !important` : `${COLORS.black2} !important`,
        // colorBgContainer: webTheme === ThemeEnum.light ? `${COLORS.primary} !important` : `${COLORS.black3} !important`,
        colorBgContainerDisabled:
            webTheme === ThemeEnum.light ? `${COLORS.gray3} !important` : `${COLORS.gray2} !important`,
        colorBgElevated: webTheme === ThemeEnum.dark ? `${COLORS.black3} !important` : `${COLORS.white} !important`,
        colorPrimary: `${COLORS.primary} !important`,
        colorErrorBorder: COLORS.red,
        boxShadow: 'transparent',
        fontFamily: 'dana',
        controlHeight: 44,
        fontSize: 16,
        borderRadius: 10,
        paddingContentHorizontal: 24,
    },
});
